<template>
  <div>
    <div class="common-title">
      <div class="common-title-icon-left">
        <div class="icon-back" v-if="iconLeft === 'back'" v-on:click="goBack">	
          <img src="../assets/back1.png" />
        </div>

       
      </div>
      <div class="common-title-name">{{titleName}}</div>
      <div class="common-title-icon-right">
       
      </div>
    </div>
    <div class="common-title-block"></div>
  </div>
</template>
<script>
export default {
  props: {
    iconLeft: String,
    titleName: String
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>
<style lang='scss' scoped>
.common-title {
  z-index: 99;
  position: fixed;
  top: 0px;
  left: 0px;
 width: 720px;
  width: 100%;
  height: 91px;
  border-bottom: 1px solid #EAEAEA;
 background: white;
  display: flex;
  padding: 0px 26px;
  justify-content: space-between;
  box-sizing: border-box;
  &-icon-left {
    line-height: 91px;
    transform: translateY(12%);
    img {
		margin-top: 10px;
      width: 100%;
      height: 100%;
    }

    .icon-back {
      width:48px;
      height: 48px;
    }
  }
  &-name {
    line-height: 91px;
    font-size: 34px;
    color: #000;
  }
  
}

.common-title-block{
  width: 100%;
  height: 91px;
}

</style>